import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";
const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
  pending: "Pending",
};
const Columns = ({ handleView, currentPage, pageSize }) => {
  return [
    {
      dataField: "",
      text: "SrNo",
      formatter: (cell, row, rowIndex) => (
        <span className="text-capitalize cursor-pointer">
          {(currentPage - 1) * pageSize + (rowIndex + 1)}
        </span>
      ),
    },

    {
      dataField: "name",
      text: "Name",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row.name}</span>
      ),
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.email || "--"}
        </span>
      ),
    },
    {
      dataField: "message",
      text: "Message",
      formatter: (_, row) => {
        const words = row?.message?.split(" ") || [];
        const truncatedMsg =
          words.length > 20
            ? words.slice(0, 20).join(" ") + " ..."
            : row.message;
        return (
          <span className="text-capitalize cursor-pointer">{truncatedMsg}</span>
        );
      },
    },
    {
      text: "Created At",
      dataField: "createdAt",
      formatter: (_, row) => DATE_FORMAT(row.createdAt),
    },
    {
      text: "Action",
      dataField: "",
      formatter: (_, row) => (
        <>
          <span className="d-flex gap-1">
            <button
              className="fa fa-eye"
              style={{
                fontSize: "20px",
                color: "green",
                backgroundColor: "#fff",
                border: "none",
              }}
              title="View"
              onClick={() => handleView(row)}
            ></button>
          </span>
        </>
      ),
    },
  ];
};

export default Columns;
